export default {

  required: {
    message : "Please enter account address.",
    fn      : (input)=> input.length,
  },

  format: {
    message : (opts)=>  {
      const msg = {
        1:"Please enter proper email.",
      };

      return msg[opts.selectedType.currencyId];
    },
    fn : (input, opts)=> {
      const validator = {
        1: Boolean(input.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/))
      };

      return validator[opts.selectedType.currencyId];
    }

  }
}
